module.exports = __webpack_public_path__ + "img/ios_doctor.828ffb78.png";